module.exports = __webpack_public_path__ + "img/icon-error-ani.ebd5864d.gif";